import { useEffect, useRef } from 'react'; // Same as useEffect, but don't gets fired on component mount

export var useDidUpdateEffect = function useDidUpdateEffect(effect, deps) {
  var didMountRef = useRef(false);
  useEffect(function () {
    if (didMountRef.current) {
      return effect();
    } else {
      didMountRef.current = true;
    }
  }, deps);
};